import { FACEBOOK_MESSENGER_URL } from 'src/constants';
import { PageCategory } from 'src/lib/api';

const namespace = {
	pageNotFound: 'Síða fannst ekki',
	backToHomepage: 'Aftur á heimaskjá',
	appVersion: 'Útgáfa',
	deleteAccount: 'Eyða aðgangi',
	areYouSureYouWantToDeleteYourAccount:
		"Ertu viss um að þú viljir eyða þínum aðgangi? Þessi aðgerð er óafturkræf og með því að smella á 'Eyða' verður öllum þínum upplýsingum og gögnum eytt!",
	delete: 'Eyða',
	cancel: 'Hætta við',
	[PageCategory.handbook]: 'ITS handbókin',
	[PageCategory.recipes]: 'Uppskriftir',
	[PageCategory.workoutProgram8Weeks]: 'Æfingaprógram 8 vikur',
	[PageCategory.runningProgram8Weeks]: 'Hlaupaprógram 8 vikur',
	[PageCategory.workoutProgram8WeeksMaster]: 'Æfingaprógram 8 vikur masters',
	[PageCategory.cooling]: 'Kæling',
	[PageCategory.breathing]: 'Öndun',
	[PageCategory.stretchesIngaBirna]: 'Teygjur með Ingu Birnu',
	reviews: 'Yfirferð',
	login: 'Innskráning',
	password: 'Lykilorð',
	measurements: 'Mælingar',
	email: 'Netfang',
	diaries: 'Skráningar',
	missingEmail: 'Það vantar netfang',
	missingPassword: 'Það vantar lykilorð',
	loginFail: 'Innskráning mistókst',
	home: 'Heim',
	changePhoto: 'Breyta mynd',
	greenStreakDescription: `Á græna svæðinu ert þú að viðhalda 95% nákvæmni á macros gildum þínum
	innan dagsins. Með því eru þú að leggja inn vinnu sem mun til lengri tíma
	skila frábærum árangri. Nýttu þér þetta og reyndu að ná sem flestum dögum
	grænum.`,
	contentIsComingSoon: 'Efni væntanlegt',
	log: 'Skráning',
	menu: 'Valmynd',
	comment: 'Athugasemd',
	changeSaved: 'Breyting vistuð',
	changeSaveFailed: 'Ekki tókst að vista breytingu',
	userInitialInfoOverview: 'Markmiðin mín',
	gender: 'Kyn',
	height: 'Hæð',
	goal: 'Markmið',
	name: 'Nafn',
	errorOccurred: 'Villa kom upp, vinsamlegast reynið aftur síðar',
	postalCode: 'Póstnúmer',
	myFitnessPal: 'My Fitness Pal',
	meditation: 'Hugleiðsla',
	nutritionTables: 'Næringartöflur',
	takePhoto: 'Taka mynd',
	pickPhotoFromGallery: 'Velja mynd',
	miscellaneous: 'Ýmislegt',
	essays: 'Pistlar',
	trendingProducts: 'Trending vörur',
	video: 'Video',
	macrosStories: 'Pepp macros sögur',
	tips: 'Gullmolar/pepp',
	yoga: 'Yoga',
	articles: 'Greinar',
	beginning: 'Upphafið',
	itsIndex: 'ITS stuðull',
	myGoals: 'Markmiðin mín',
	education: 'Fræðsla',
	messenger: 'Messenger',
	macrosExperience: 'Reynsla af macros',
	location_note: 'Búseta',
	residence: 'Búseta',
	birthdate: 'Afmælisdagur',
	noResults: 'Engar niðurstöður',
	resetPassword: 'Endurstilla lykilorð',
	code: 'Kóði',
	missingCode: 'Vantar kóða',
	passwordsDontMatch: 'Lykilorð eru ekki eins',
	uploadPhoto: 'Hlaða upp mynd',
	passwordConfirmation: 'Staðfesting lykilorðs',
	iLiveOutsideIceland: 'Ég bý erlendis',
	progress: 'Árangur',
	userPersonalGoalsPage: {
		ifYouWantToChangeYourPersonalGoalsContactUsViaMessenger: `Ef þú vilt breyta markmiðum þínum, hafðu þá samband við okkur í gegnum <a href="${FACEBOOK_MESSENGER_URL}">messenger</a>`,
	},
	genderOptions: {
		male: 'Karl',
		female: 'Kona',
		other: 'Kynsegin/annað',
	},
	personalGoals: {
		haveYouTriedMacrosBefore:
			'Hefur þú verið hjá okkur áður eða prufað macros?',
		haveYouTriedMacrosBeforePleaseTellUsMore:
			'Segðu okkur endilega frá því og hvaða tölur þú notaðist við og hvernig það gekk',
		tellUsAboutYourself: 'Segðu okkur aðeins frá þér!',
		whatIsYourGender: 'Hvað er þitt kyn?',
		whenWereYouBorn: 'Hvenær fæddist þú?',
		whereDoYouLive: 'Hvar býrðu?',
		whatIsYourWeight: 'Hver er þyngdin þín? (kg)',
		whatIsYourHeight: 'Hver er hæðin þín? (cm)',
		whatAreYourGoals: 'Hver eru þín markmið?',
		exercisesEveryWeek: 'Hreyfing í hverri viku',
		exercisesEveryWeekSubtitle:
			'Lýstu nokkuð nákvæmlega hvernig hreyfingu er háttað hjá þér í hverri viku',
		whatIsYourJob: 'Við hvað starfar þú?',
		foodTitle: 'Sérstakt fæði',
		whatAppliesToYou: 'Hvað á við þig?',
		situationTitle: 'Sérstakar aðstæður',
		yourStrengths: 'Þínir styrkleikar',
		nameSomethingThatWouldBeFunToKnowAboutYou:
			'Nefndu eitthvað sem væri skemmtilegt að vita um þig',
		somethingElseYouWouldLikeUsToKnowAboutYou:
			'Annað sem þú vilt koma á framfæri um þína heilsu eða þinn bakgrunn',
		oneThingYouAreProudOf: 'Eitt sem þú ert afar stolt/stoltur af :)',
		howDidYouHearAboutUs: 'Hvernig fréttir þú af okkur?',
		makeSureAllOfYourInformationIsCorrect:
			'Vertu viss um að allar upplýsingarnar sem þú settir inn séu réttar',
		gainWeight: 'Þyngjast',
		loseWeight: 'Léttast',
		increaseEnergy: 'Auka orku',
		getStronger: 'Styrkjast',
		increaseMuscleMass: 'Auka vöðvamassa',
		feelBetter: 'Betri líðan',
		knowMoreAboutNutrition: 'Auka þekkingu mína á næringu',
		betterSleep: 'Betri svefn',
		betterMood: 'Bæta skap',
		getToned: 'Tónast',
		feelBetterAboutMyself: 'Líða betur með mig',
		increaseConfidence: 'Aukið sjálfstraust',
		startExercising: 'Fara að hreyfa mig',
		decreaseInflammationAndPain: 'Minnka bólgur og verki',
		decreaseSugarCraving: 'Minnka sykurlöngun',
		eatAlmostAnything: 'Borða nánast allt',
		vegan: 'Vegan',
		dontEatMeat: 'Borða ekki kjöt',
		dontEatDairy: 'Borða ekki mjólkurvörur',
		vegetarian: 'Grænmetisæta',
		breastfeeding: 'Með barn á brjósti',
		pregnant: 'Ófrísk',
		foodAllergies: 'Fæðuofnæmi',
		hormoneImbalance: 'Hormóna ójafnvægi',
		menopause: 'Breytingaskeið',
		hadEatingDisorder: 'Saga um átröskun',
		viaFamilyMember: 'Hjá fjölskyldumeðlim',
		viaFriend: 'Hjá vin',
		viaCoworker: 'Hjá vinnufélaga',
		sawAnAd: 'Sá auglýsingu',
		job: 'Starf',
		funToKnow: 'Skemmtilegt að vita',
		somethingElse: 'Annað',
		proud: 'Stolt',
		exercise: 'Hreyfing',
		goalExplanation: 'Útskýring á markmiðum',
		food: 'Matur',
		situation: 'Aðstæður',
		specialCircumstanceNothingAppliesToMe: 'Ekkert af ofangreindu á við mig',
	},
	month: {
		january: 'janúar',
		february: 'febrúar',
		march: 'mars',
		april: 'apríl',
		may: 'maí',
		june: 'júní',
		july: 'júlí',
		august: 'ágúst',
		september: 'september',
		october: 'október',
		november: 'nóvember',
		december: 'desember',
	},
	diaryForm: {
		didNotCountMacros: 'Skráði ekki',
		carbs: 'Kolvetni',
		protein: 'Prótein',
		fat: 'Fita',
		fiber: 'Trefjar',
		aLittle: 'Smá',
		hunger: 'Hungur',
		foodQuality: 'Gæði matar',
		hours: 'klst',
		sleep: 'Svefn',
		energy: 'Orka',
		exercise: 'Æfing',
		submitMacros: 'Skrá',
		howAreYouFeelingToday: 'Hvernig líður þér í dag?',

		waterIntake: 'Vatn',
		tookVitamins: 'Vítamín',

		hungerDescription: 'Fannstu fyrir hungri almennt yfir daginn?',

		foodQualityDescription: {
			low: 'Valdi ekki góða næringu í dag og vandaði ekki valið.',
			medium: 'Gæðin voru góð í dag en hefði getað vandað valið betur',
			high: ' Frábær gæði valin. Vandaði valið mjög vel',
		},

		energyDescription: {
			low: 'Orkan var mjög lág',
			medium: 'Orkan var allt í lagi en mætti vera meiri',
			high: 'Mjög mikil orka, ég var óstöðvandi!',
		},

		exerciseDescription: {
			no: 'Engin æfing/ hreyfing í dag',
			lowPulse:
				'Æfing eða hreyfing þar sem púlsinn er lægri en á erfiðis æfingu. Þetta getur t.d. verið rösk ganga, hægt hlaup, rólegt hjól, rólegt sund eða þess háttar. Ættir að geta haldið uppi spjalli með þennan púls.',
			highPulse:
				'Æfing þar sem púlsinn er hár megnið af tímanum. Til dæmis hlaup, crossfit, lyftingar, úthaldsæfingar, hjólreiðar/spinning, æfingar í líkamsrækt eða keppnisleikir.',
		},
		sleepDescription: 'Hvað svafstu margar klst í nótt?',
		addComment: 'Bæta við athugasemd',
	},
	measurementForm: {
		weight: 'Þyngd',
		chest: 'Brjóst',
		stomach: 'Magi',
		leftUpperArm: 'Vinstri upphandleggur',
		rightUpperArm: 'Hægri upphandleggur',
		hips: 'Mjaðmir',
		leftThigh: 'Vinstra læri',
		rightThigh: 'Hægra læri',
		submitMeasurement: 'Skrá mælingu',
		kg: 'kg',
		cm: 'cm',
		allMeasurements: 'Mælingar samanlagðar',
		uploadFrontPhoto: 'Mynd - framan',
		uploadSidePhoto: 'Mynd - á hlið',
	},
	assignmentForm: {
		submitAssignment: 'Skrá verkefni',
	},
	macrosWeekLogs: {
		macrosLoggedThisWeek: 'macros skráningar fyrir vikuna',
	},
	logOut: 'Útskráning',
	yes: 'Já',
	no: 'Nei',
	lowPulse: 'Lág-púls',
	submissionFailed: 'Villa kom upp við skráningu',
	mondayAbbreviation: 'M',
	tuesdayAbbreviation: 'Þ',
	wednesdayAbbreviation: 'M',
	thursdayAbbreviation: 'F',
	fridayAbbreviation: 'F',
	saturdayAbbreviation: 'L',
	sundayAbbreviation: 'S',
	weekSubmissions: 'Skráningar vikunnar',
	measurement: 'Mæling',
	assignment: 'Verkefni',
	notifications: 'Tilkynningar',
	diaryWeekLogs: 'Skráningar vikunnar',
	measurementWeekLogs: 'Mælingar vikunnar',
	change: 'Breyta',
	nextStep: 'Næsta',
	continue: 'Áfram',
	select: 'Veldu',
	submit: 'Staðfesta',
	profile: 'Reikningurinn minn',
};

export default namespace;
